import React from "react";
import _ from "lodash";
import { t } from "i18next";
import TranslatedString from "Components/TranslatedString";
import Divider from "Components/divider/Divider";

import cx from "classnames";
import s from "./detailsDelegates.scss";

export default class Details extends React.Component {
  constructor(props) {
    super(props);
    let visualizationPeriod;
    if (props.delegate.visualization_start) {
      let start = new Date(props.delegate.visualization_start).toLocaleDateString();
      let end = new Date(props.delegate.visualization_end).toLocaleDateString();
      visualizationPeriod = `${start} -  ${end}`;
    } else {
      visualizationPeriod = t("detailInfo.data.messages.viewDate.noLimits");
    }

    let domainsEmails = {};
    _.each(props.delegate.email_accounts, (em) => {
      if (!domainsEmails[em.domain_name]) {
        domainsEmails[em.domain_name] = [];
      }

      domainsEmails[em.domain_name].push(em);
    });

    this.state = { visualizationPeriod, domainsEmails };
  }

  render() {
    const { delegate } = this.props;
    const { domainsEmails, visualizationPeriod } = this.state;
    let counter = 0;
    return (
      <div className={s.registry}>
        <div className={s.settings}>
          <div className="sectionSP">
            <div className="infoSectionSP">
              <div className="settingTitle">{t("settings.sections.delegate.info.title")}</div>
            </div>
            <div className="formsSectionSP">
              <div className={cx("inputFull2", s.sectionRecap)}>
                <div className={s.labelRecapt}>{t("detailInfo.label.messages.viewDate")}</div>
                <div className={s.dataRecapt}>{visualizationPeriod}</div>
              </div>

              <div className={cx("inputFull2", s.sectionRecap)}>
                <div className={s.labelRecapt}>{t("detailInfo.label.permissions")}</div>
                <div className={s.dataRecapt}>
                  {_.map(domainsEmails, (ems, domainName) => {
                    counter += 1;
                    return (
                      <div className={s.wrapDomain} key={domainName}>
                        <div className={s.nameDomain}>{domainName}</div>
                        {_.map(ems, (em) => (
                          <div className={s.rowDomain} key={em.email_address}>
                            <div>{em.email_address}</div>
                            <div className={s.visualization}>
                              {t(`folderMapper.label.${em.rights}`)}
                            </div>
                          </div>
                        ))}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
